import labels from "utils/LocalizedStrings";
import Accordion from "react-bootstrap/Accordion";
import SectionFooter from "common/Footer/SectionFooter";

const GlossaryTerms = () => {
  return (
    <main id="glossary" className="dashboard-layout shadow-lg">
      <section className="section-one row py-4 glossary">
        <div className="px-0">
          <div className="header mb-4 py-1">{labels?.glossary?.title}</div>
          <div>{labels?.glossary?.description}</div>
          <Accordion defaultActiveKey="0" className="mt-4">
            {labels?.glossary?.terms?.map((e, index) => {
              return (
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header>{e.key}</Accordion.Header>
                  <Accordion.Body>{e.value}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </section>
      <SectionFooter page="learningCenter" />
    </main>
  );
};

export default GlossaryTerms;
